export enum Namensvorsatz {
  a = 'a',
  aan_de = 'aan de',
  aan_den = 'aan den',
  al = 'al',
  am = 'am',
  an = 'an',
  an_der = 'an der',
  auf = 'auf',
  auf_dem = 'auf dem',
  auf_der = 'auf der',
  auf_m = 'auf m',
  aufm = 'aufm',
  auff_m = 'auff m',
  aus = 'aus',
  aus_dem = 'aus dem',
  aus_den = 'aus den',
  aus_der = 'aus der',
  b = 'b',
  be = 'be',
  bei = 'bei',
  bei_der = 'bei der',
  beim = 'beim',
  ben = 'ben',
  bey = 'bey',
  bey_der = 'bey der',
  che = 'che',
  cid = 'cid',
  d = 'd',
  d_DOT = 'd.',
  d_QUOTE = "d'",
  da = 'da',
  da_costa = 'da costa',
  da_las = 'da las',
  da_silva = 'da silva',
  dal = 'dal',
  dall = 'dall',
  dall_QUOTE = "dall'",
  dalla = 'dalla',
  dalle = 'dalle',
  dallo = 'dallo',
  das = 'das',
  de = 'de',
  degli = 'degli',
  die = 'die',
  den = 'den',
  de_l = "de l '",
  de_la = 'de la',
  de_las = 'de las',
  de_le = 'de le',
  de_los = 'de los',
  del = 'del',
  del_coz = 'del coz',
  deli = 'deli',
  dell = 'dell',
  dell_QUOTE = "dell'",
  della = 'della',
  delle = 'delle',
  delli = 'delli',
  dello = 'dello',
  der = 'der',
  des = 'des',
  di = 'di',
  dit = 'dit',
  do = 'do',
  do_ceu = 'do ceu',
  don = 'don',
  don_le = 'don le',
  dos = 'dos',
  dos_santos = 'dos santos',
  du = 'du',
  dy = 'dy',
  el = 'el',
  g = 'g',
  gen = 'gen',
  gil = 'gil',
  gli = 'gli',
  grosse = 'grosse',
  große = 'große',
  i = 'i',
  im = 'im',
  in = 'in',
  in_de = 'in de',
  in_den = 'in den',
  in_der = 'in der',
  in_het = 'in het',
  in_t = "in't",
  kl = 'kl',
  kleine = 'kleine',
  l = 'l',
  l_dot = 'l.',
  l_quote = "l'",
  la = 'la',
  le = 'le',
  lee = 'lee',
  li = 'li',
  lo = 'lo',
  m = 'm',
  mc = 'mc',
  mac = 'mac',
  n = 'n',
  o = 'o',
  o_quote = "o'",
  op = 'op',
  op_de = 'op de',
  op_den = 'op den',
  op_gen = 'op gen',
  op_het = 'op het',
  op_te = 'op te',
  op_ten = 'op ten',
  oude = 'oude',
  pla = 'pla',
  pro = 'pro',
  s = 's',
  st_DOT = 'st.',
  t = 't',
  te = 'te',
  ten = 'ten',
  ter = 'ter',
  thi = 'thi',
  tho = 'tho',
  thom = 'thom',
  thor = 'thor',
  thum = 'thum',
  to = 'to',
  tom = 'tom',
  tor = 'tor',
  tu = 'tu',
  tum = 'tum',
  unten = 'unten',
  unter = 'unter',
  unterm = 'unterm',
  v_DOT = 'v.',
  v_space_d = 'v. d.',
  v_space_dem = 'v. dem',
  v_space_den = 'v. den',
  v_space_der = 'v. der',
  v_d = 'v.d.',
  v_dem = 'v.dem',
  v_den = 'v.den',
  v_der = 'v.der',
  van = 'van',
  van_de = 'van de',
  van_dem = 'van dem',
  van_den = 'van den',
  van_der = 'van der',
  vande = 'vande',
  vandem = 'vandem',
  vanden = 'vanden',
  vander = 'vander',
  van_gen = 'van gen',
  van_het = 'van het',
  van_t = 'van t',
  ven = 'ven',
  ven_der = 'ven der',
  ver = 'ver',
  vo = 'vo',
  vom = 'vom',
  vom_und_zu = 'vom und zu',
  von = 'von',
  von_und_zu = 'von und zu',
  von_und_zu_der = 'von und zu der',
  von_und_zur = 'von und zur',
  von_de = 'von de',
  von_dem = 'von dem',
  von_den = 'von den',
  von_der = 'von der',
  von_la = 'von la',
  von_zu = 'von zu',
  von_zum = 'von zum',
  von_zur = 'von zur',
  vonde = 'vonde',
  vonden = 'vonden',
  vondem = 'vondem',
  vonder = 'vonder',
  von_einem = 'von einem',
  von_mast = 'von mast',
  vor = 'vor',
  vor_dem = 'vor dem',
  vor_den = 'vor den',
  vor_der = 'vor der',
  vorm = 'vorm',
  vorn = 'vorn',
  y = 'y',
  y_del = 'y del',
  zu = 'zu',
  zum = 'zum',
  zur = 'zur',
}
